<div ngbDropdown container="body" class="text-start">

	@if (isViewVisible()) {
	<i data-testid="SUBSYS2_PLANLIST_ACTION_VIEWCASE" class="material-icons action"
		[title]="labels().PLAN_ACTION_COMPONENT_VIEW" (click)="view()" (keypress)="view()">visibility</i>
	}
	@if (isEditVisible()) {
	<i data-testid="SUBSYS2_PLANLIST_ACTION_EDIT" class="material-icons action"
		[title]="labels().PLAN_ACTION_COMPONENT_EDIT" (click)="edit()" (keypress)="edit()"
		[class.disabled]="isReadonly()">edit</i>
	}
	@if (isDeleteVisible()) {
	<i data-testid="SUBSYS2_PLANLIST_ACTION_DELETE" class="material-icons action"
		[title]="labels().PLAN_ACTION_COMPONENT_DELETE" (click)="openDeleteModal()" (keypress)="openDeleteModal()"
		[class.disabled]="isReadonly()">delete_outline</i>
	}
	@if (isSendVisible()) {
	<i data-testid="SUBSYS2_PLANLIST_ACTION_SEND" class="material-icons action"
		[title]="labels().PLAN_ACTION_COMPONENT_SEND" (click)="openSendModal()" (keypress)="openSendModal()">send</i>
	}
	@if (isMyHexPlanSettingsVisible()) {
	<i data-testid="SUBSYS2_PLANLIST_ACTION_MYHEXPLAN_SETTINGS" class="material-icons action"
		[title]="labels().PLAN_ACTION_COMPONENT_MYHEXPLAN_SETTINGS" (click)="viewPlanSettings()"
		(keypress)="viewPlanSettings()" [class.disabled]="isReadonly()">settings_applications</i>
	}
	@if (isPostopCreateVisible()) {
	<i data-testid="SUBSYS2_PLANLIST_ACTION_POSTOPCREATE" class="material-icons action fake-material-icon postoperative"
		[title]="labels().PLAN_ACTION_COMPONENT_POSTOP_CREATE" (click)="openPostopCreateModal()"
		(keypress)="openPostopCreateModal()" [class.disabled]="isReadonly()"></i>
	}
	@if (isAnalysisVisible()) {
	<i data-testid="SUBSYS2_PLANLIST_ACTION_ANALYSIS" class="material-icons action"
		[title]="labels().PLAN_ACTION_COMPONENT_GO_RAY" (click)="navigateToApp()"
		(keypress)="navigateToApp()">square_foot</i>
	}
	@if (isUpgradeVisible()) {
	<i data-testid="SUBSYS2_PLANLIST_ACTION_UPGRADE" class="material-icons action"
		[title]="labels().PLAN_ACTION_COMPONENT_UPGRADE" (click)="openUpgradeModal()"
		(keypress)="openUpgradeModal()">upgrade</i>
	}
</div>